/**
 * @param  {String} id - the raw path to be parsed into RHF (eg. '$policy.who')
 * @returns {String} the RHF converted key (eg. 'policy::who')
 */
const convertFieldIDtoRHF = (id) => (
	id.replace(/\$/g, '').replace(/\./g, '::')
);

export default convertFieldIDtoRHF;
